import { createSlice } from "@reduxjs/toolkit";
import { loginUser, logoutUser } from "./thunk";

export const initialState = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error indicator
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    reset_login_flag(state) {
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.errorMsg = false;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.errorMsg = false;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
        state.errorMsg = true;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.isUserLogout = true;
        state.user = {};
      });
  }
});

export const {
  reset_login_flag
} = loginSlice.actions;

export default loginSlice.reducer;
